/**
 * 📈 LINE CHART WIDGET
 * ════════════════════════════════════════════════════════════════════════
 * 
 * Widget para gráficos de línea (TRENDS).
 * Props mínimas, sin lógica de layout.
 */

import React from 'react';
import { LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid, Area, AreaChart } from 'recharts';
import type { ExecutiveWidget } from '../types';
import { getWidgetSeriesCache } from '../../../shared/utils/seriesCache';

interface LineChartWidgetProps {
  widget: ExecutiveWidget;
}

const LineChartWidget: React.FC<LineChartWidgetProps> = ({ widget }) => {
  
  const { detectedXField } = getWidgetSeriesCache({
    widgetId: widget.id,
    data: widget.data,
    defaultXField: 'date',
    defaultYField: 'valor',
  });
  const yField = 'valor';
  
  if (!detectedXField || !widget.data || widget.data.length === 0) {
    return <div className="widget-empty">Sin datos</div>;
  }
  
  return (
    <div className="line-chart-widget">
      <h3 className="widget-title">{widget.title}</h3>
      <ResponsiveContainer width="100%" height="100%">
        <AreaChart data={widget.data} margin={{ top: 10, right: 20, left: 0, bottom: 5 }}>
          <defs>
            <linearGradient id="colorValue" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor="#10b981" stopOpacity={0.4}/>
              <stop offset="95%" stopColor="#10b981" stopOpacity={0}/>
            </linearGradient>
          </defs>
          <CartesianGrid strokeDasharray="3 3" stroke="rgba(255,255,255,0.05)" vertical={false} />
          <XAxis 
            dataKey={detectedXField} 
            stroke="rgba(255,255,255,0.15)"
            tick={{ fill: '#6b7280', fontSize: 12 }}
          />
          <YAxis 
            stroke="rgba(255,255,255,0.15)"
            tick={{ fill: '#6b7280', fontSize: 12 }}
          />
          <Tooltip
            contentStyle={{
              backgroundColor: '#1e2732',
              border: '1px solid rgba(255,255,255,0.1)',
              borderRadius: '8px',
              color: '#f0f4f8'
            }}
            labelStyle={{ color: '#f0f4f8', marginBottom: 4 }}
            itemStyle={{ color: '#10b981' }}
          />
          <Area
            type="monotone"
            dataKey={yField}
            stroke="#10b981"
            strokeWidth={3}
            fill="url(#colorValue)"
            fillOpacity={0.2}
          />
          <Line 
            type="monotone" 
            dataKey={yField} 
            stroke="#10b981" 
            strokeWidth={3}
            dot={false}
            activeDot={{ r: 6, fill: '#10b981' }}
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
};

export default LineChartWidget;
